const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

const menu = [
  {
    text: "Home",
    to: "/",
  },
  {
    text: "Notícias",
    to: "/noticias",
  },
  {
    text: "Eventos",
    to: "/eventos",
  },
  {
    text: "Vídeos",
    to: "/videos",
  },
  {
    text: "Quem Somos",
    to: "/quem-somos",
  },
  {
    text: "Contato",
    to: "/contato",
  },
];

export { server, menu };
